import styles from './AssignPasscode.css'
import AuthorizationCodeField from 'components/Fields/ReduxForm/AuthorizationCodeField'
import {Field, untouch} from 'redux-form'
import {Link} from 'react-router'

class AssignPasscode extends React.Component {
  render () {
    const {assignPin, selfView} = this.props
    let className = (assignPin) ? styles['show-pin'] : styles['hide-pin']
    return <div>
      <div className={`${styles['checkbox-wrapper']} col-xs-1`}>
        <Field
          component='input'
          type='checkbox'
          name='assign_pin'
          disabled={selfView}
          onChange={this._onChangeCheckbox}
        />
      </div>
      <div className={`${styles['passcode-wrapper']} col-xs-11`}>
        <div>
          <span>Assign a PIN</span>
        </div>
        <div className={`${styles['auth-code-text']}`}>
          <small>PIN will be used for in app permission on <Link to='/employees/pin'>PIN Access page</Link></small>
        </div>
        <Field
          name='pin'
          component={AuthorizationCodeField}
          placeholder='4 Digits PIN'
          maxLength={4}
          className={className}
          disabled={selfView}
        />
      </div>
    </div>
  }

  _onChangeCheckbox = () => {
    if (!this.props.currentPin || this.props.currentPin === '') {
      this.props.dispatch(untouch('staff', 'pin'))
    }
  }
}

AssignPasscode.propTypes = {
  assignPin: React.PropTypes.bool,
  selfView: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  currentPin: React.PropTypes.string
}
export default AssignPasscode



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffDetail/StaffForm/AssignPasscode/AssignPasscode.js